import { ReactComponent as NotificationIconSVG } from "./notification-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconNotification(props) {
  return <SvgIcon {...props} component={NotificationIconSVG} viewBox="0 0 16 20" />;
}